export class Application {
  constructor({
    id = null,
    nom = null,
    applicationTypeId = null,
    droitsDisponible = [],
    configTemplate = [],
    monoAgence = null
  } = {}) {
    this.id = id;
    this.nom = nom;
    this.applicationTypeId = applicationTypeId;
    this.droitsDisponible = droitsDisponible;
    this.configTemplate = configTemplate;
    this.monoAgence = monoAgence;
  }
}
